/**
 * Crunch Design System — Select
 *
 * Figma component: select (component set, node 3968:7522)
 *
 * Usage:
 *   <InputGroup label="Country">
 *     <Select>
 *       <option value="">Choose…</option>
 *       <option value="us">United States</option>
 *     </Select>
 *   </InputGroup>
 */
import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@awesome.me/kit-8a0d2fd588/icons/modules/classic/light';

export const Select = React.forwardRef<HTMLSelectElement, {
    size?: "default" | "small";
    error?: boolean;
    readOnly?: boolean;
    disabled?: boolean;
    leadingIcon?: React.ReactNode;
    children?: React.ReactNode;
    className?: string;
    [key: string]: any;
}>(function Select(
    {
        size = "default",
        error = false,
        readOnly = false,
        disabled = false,
        leadingIcon,
        children,
        className,
        ...rest
    },
    ref,
) {
    const cls = [
        "cr-select",
        size !== "default" && `cr-select--${size}`,
        error && "cr-select--danger",
        readOnly && "cr-select--readonly",
        disabled && "cr-select--disabled",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <label className={cls}>
            {leadingIcon && <span className="cr-select__icon">{leadingIcon}</span>}
            <select
                className="cr-select__control"
                disabled={disabled || readOnly}
                ref={ref}
                {...rest}
            >
                {children}
            </select>
            <FontAwesomeIcon icon={faAngleDown} className="cr-select__chevron" aria-hidden />
        </label>
    );
});
